export const resolveVisibleActions = (actions, isEdit, status, handlers, isDocument) => {

    const ACTIONS_HIDDEN_BY_STATUS = {
        Draft: ["publish", "approve", "reject", "downloadWord", "downloadPDF"],
        Review: ["save_send", "publish", "downloadWord", "downloadPDF"],
        Approved: ["save_send", "reject", "approve", "downloadWord", "downloadPDF"],
        Published: ["publish", "save_send", "reject", "approve"],
        Obsolete: ["publish", "save_send", "reject", "approve", "downloadWord", "downloadPDF", "obsolete"],
        Publishing: ["save_send", "reject", "approve", "downloadWord", "downloadPDF", "publish"],
    }
        
    let visibleActions = [];
    let downloadsActions = ["downloadWord", "downloadPDF"];

    if (isEdit) {
        if(status === undefined && isDocument) {
            return;
        }
        if (ACTIONS_HIDDEN_BY_STATUS[status]) {
            visibleActions = actions.filter(action => !ACTIONS_HIDDEN_BY_STATUS[status].includes(action));
        } else {
            visibleActions = actions;
        }

        if (status === "Approved" || status === "Published") {
            visibleActions = actions.filter(action => !ACTIONS_HIDDEN_BY_STATUS[status].includes(action));
            visibleActions = [...visibleActions, ...downloadsActions];
        }
    } else {
        visibleActions = handlers.create ? actions : actions.filter(action => action === "save");
    }

    return visibleActions;
};